import Constant from '@/common/constant/Constant';
import ProductManagementConstant from '@/common/constant/ProductManagementConstant';
import localStorageUtil from '@/common/utils/localStorageUtil';
import Utils from '@/common/utils/utils';
import OpenAiUtil from '@/common/utils/OpenAiUtil';
import { multiPanelAtom } from '@/state/atom/panelAtom';
import { useEffect, useState } from 'react';
import { useRecoilState } from 'recoil';
import EditionList from './EditionList';
import ProductList from './ProductList';
import VersionList from './VersionList';
import {  updatePanelEditionList } from './handler/ProductListHandler';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { getCorporationDetailByCorporationDomain } from '@/service/organizationService';

import PropTypes from 'prop-types';
ProductManagement.propTypes = {
    API: PropTypes.any,
    panelId: PropTypes.any,
    tabId: PropTypes.any
};
export default function ProductManagement(props) {
    const [openComponent, setOpenComponent] = useState(ProductManagementConstant.PRODUCT_LIST);
    const [panelList, setPanelList] = useRecoilState(multiPanelAtom);
    const [dataProduct, setDataProduct] = useState({})
    const [openDropDownVersion, setOpenDropDownVersion] = useState([]);
    const [listGptModel, setListGptModel] = useState([]);
    const [corporationDetail, setCorporationDetail] = useRecoilState(corporationAtom);

    useEffect(() => {
        (async () => {
            let gptModelList = OpenAiUtil.getListChatGptModelFromCorpDetail(corporationDetail, true);
            if (gptModelList.length === 0) {
                // try get from api
                let domain = await localStorageUtil.getCorporationDomain();
                let corpDetail = await getCorporationDetailByCorporationDomain(null, domain);
                gptModelList = OpenAiUtil.getListChatGptModelFromCorpDetail(corpDetail, true);
                setCorporationDetail(corpDetail);
            }
            setListGptModel(gptModelList);
        })()
    }, []);

    useEffect(() => {
        const panelProductList = panelList.find(panel =>
            [Constant.PANEL_TYPE.PRODUCT_MANAGEMENT].includes(panel.type)
        );
        if (!Utils.isEmptyObject(panelProductList)) {
            let tab = panelProductList?.tabList[0];
            setDataProduct(tab.productInfo)
            if (!Utils.isEmptyObject(tab) && tab?.componentType) {
                setOpenComponent(tab?.componentType);
            }
        }
    }, [panelList]);

    const onClickOpenComponent = (data, panelType) => {
        setOpenComponent(panelType);
        updatePanelEditionList(panelList, setPanelList, data, panelType);
        setDataProduct(data)
    };

    const renderComponent = () => {
        switch (openComponent) {
            case ProductManagementConstant.PRODUCT_LIST:
                return (
                    <ProductList
                        API={props?.API}
                        onOpenEditionList={onClickOpenComponent}
                        panelId = {props.panelId}
                        tabId = {props.tabId}
                    />
                );
            case ProductManagementConstant.EDITION_LIST:
                return (
                    <EditionList
                        API={props?.API}
                        onOpenVersionList={onClickOpenComponent} 
                        dataProduct={dataProduct}
                        panelId = {props.panelId}
                        tabId = {props.tabId}
                        openDropDownVersion = {openDropDownVersion}
                        setOpenDropDownVersion = {setOpenDropDownVersion}
                        listGptModel={listGptModel}
                    />
                );
            case ProductManagementConstant.VERSION_LIST:
                return (
                    <VersionList 
                        props={props}
                        API={props?.API}
                        dataProduct={dataProduct}
                        onBackEditionPanel={onClickOpenComponent}
                        panelId = {props.panelId}
                        tabId = {props.tabId}
                        setOpenDropDownVersion = {setOpenDropDownVersion}
                        listGptModel={listGptModel}
                    />
                );
            default:
                return <ProductList />;
        }
    };

    return <>{renderComponent()}</>;
}
